import { render } from "./LoadingOffer.vue?vue&type=template&id=2ea5377d&scoped=true&ts=true"
import script from "./LoadingOffer.vue?vue&type=script&lang=ts"
export * from "./LoadingOffer.vue?vue&type=script&lang=ts"

import "./LoadingOffer.vue?vue&type=style&index=0&id=2ea5377d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea5377d"]])

export default __exports__